var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex-element',{attrs:{"element-type":_vm.elementType,"tag":"li"}},[(_vm.elements[0])?_c(_vm.elements[0].elementType,_vm._b({tag:"component",on:{"element-updated":_vm.elementUpdated}},'component',_vm.element(1),false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }